import axios from '../external/Axios';
import Url from '../constants/Url';

class PrizeApi {
    get(params) {
        return axios
            .get(Url().PRIZE.GET, {params}) // `lang` query param (eg: ?lang=en)
            .then(res => {
                return res.data.data;
            })
            .catch(ex => {
                console.info('Failed to get:', ex.message, ex);
                throw ex;
            });
    }
}

export default new PrizeApi();
